import { render, staticRenderFns } from "./AccountLayout.vue?vue&type=template&id=754e777a&scoped=true&"
import script from "./AccountLayout.vue?vue&type=script&scoped=true&lang=js&"
export * from "./AccountLayout.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./AccountLayout.vue?vue&type=style&index=0&id=754e777a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754e777a",
  null
  
)

export default component.exports